export const originsConf: { [key: string]: { color?: string, ym?: { [key: string]: unknown } } } = {

    'localhost': {
        color: '#3f4bb2',
    },

    'undefined-site': {
        color: '#3f4bb2',
    },

    'letolifefest.ru': {
        color: '#3f4bb2', //#e91e63
        ym: {
            id: '44683600',
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            // ecommerce: "dataLayer",
            //webvisor: true,
            //trackHash: true
        }
    },

    'peachrest.ru': {
        color: '#d02c2f',
        ym: {
            id: '85871352',
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            // ecommerce: "dataLayer",
            //webvisor: true,
            //trackHash: true
        }
    },

}
